import rementeLogoWhite from './logo-remente-white.svg';
import rementeLogo from './logo-remente.svg';
import noTextRementeLogo from './no-text-logo-remente.svg';
import { useDarkMode } from '../context/DarkmodeContext';

export const RementeLogo = ({
  width = 120,
  noText,
}: {
  width?: string | number;
  noText?: boolean;
}) => {
  const { isDarkMode } = useDarkMode();

  if (noText) {
    return <img src={noTextRementeLogo} alt="Remente logo" width={50} />;
  }

  if (isDarkMode) {
    return <img src={rementeLogoWhite} alt="Remente logo" width={width} />;
  } else {
    return <img src={rementeLogo} alt="Remente logo" width={width} />;
  }
};
